var map = {
	"./Capture.jpg": 6644,
	"./access_map.jpg": 9128,
	"./appearance.jpg": 7451,
	"./doctor.jpg": 4748,
	"./exam_room.jpg": 5454,
	"./parking.jpg": 8397,
	"./room_1.jpg": 8822,
	"./room_2.jpg": 798,
	"./room_3.jpg": 9473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;